import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './LoginPage.css';

const baseEnvironment = process.env.REACT_APP_API_BASE_URL?.trim() || 'http://localhost:8010';
const API_BASE_URL = baseEnvironment.replace(/\/$/, '');
const APP_LOGO_SRC = `${process.env.PUBLIC_URL || ''}/Rationexus-Logo.png`;

function ActivatePage() {
  const { token } = useParams();
  const navigate = useNavigate();

  const [status, setStatus] = useState('loading');
  const [username, setUsername] = useState('');
  const [passwords, setPasswords] = useState({ newPassword: '', confirmPassword: '' });
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const validateToken = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/auth/activation/${token}`);
        const data = await response.json().catch(() => null);
        if (cancelled) {
          return;
        }
        if (response.ok && data?.valid) {
          setUsername(data.username || '');
          setStatus('form');
        } else {
          setStatus('invalid');
        }
      } catch (caught) {
        if (!cancelled) {
          setStatus('invalid');
        }
      }
    };

    validateToken();
    return () => {
      cancelled = true;
    };
  }, [token]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setPasswords((current) => ({ ...current, [name]: value }));
  };

  const submitActivation = async (event) => {
    event.preventDefault();
    setError('');

    if (passwords.newPassword !== passwords.confirmPassword) {
      setError('Şifreler eşleşmiyor.');
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/activation/${token}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(passwords),
      });

      if (!response.ok) {
        const payload = await response.json().catch(() => null);
        throw new Error(payload?.message ?? 'Aktivasyon başarısız oldu.');
      }

      navigate('/login', { replace: true, state: { activated: true } });
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : 'Aktivasyon sırasında bir hata oluştu.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const isFormValid = passwords.newPassword.trim().length >= 8 && passwords.confirmPassword.trim();

  if (status === 'loading') {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <img src={APP_LOGO_SRC} alt="RatioNexus" className="auth-logo" />
          <h1>RatioNexus</h1>
          <p className="subtitle">Aktivasyon bağlantısı doğrulanıyor…</p>
        </div>
      </div>
    );
  }

  if (status === 'invalid') {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <img src={APP_LOGO_SRC} alt="RatioNexus" className="auth-logo" />
          <h1>RatioNexus</h1>
          <p className="subtitle">Bu aktivasyon bağlantısı geçersiz veya süresi dolmuş.</p>
          <p className="error">Yeni bir bağlantı için lütfen destek ekibiyle iletişime geçin.</p>
          <button type="button" onClick={() => navigate('/login')}>
            Giriş sayfasına dön
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <img src={APP_LOGO_SRC} alt="RatioNexus" className="auth-logo" />
        <h1>RatioNexus</h1>
        <p className="subtitle">
          {username ? `${username} için hesabınızı aktifleştirin` : 'Hesabınızı aktifleştirin'}
        </p>
        <form onSubmit={submitActivation}>
          <label>
            Yeni şifre
            <input
              type="password"
              name="newPassword"
              autoComplete="new-password"
              value={passwords.newPassword}
              onChange={handleChange}
            />
          </label>
          <label>
            Yeni şifre (tekrar)
            <input
              type="password"
              name="confirmPassword"
              autoComplete="new-password"
              value={passwords.confirmPassword}
              onChange={handleChange}
            />
          </label>
          <button type="submit" disabled={!isFormValid || isSubmitting}>
            {isSubmitting ? 'Kaydediliyor…' : 'Şifreyi Belirle ve Aktifleştir'}
          </button>
        </form>
        <p className="error">{error || 'Şifreniz en az 8 karakter olmalıdır.'}</p>
      </div>
    </div>
  );
}

export default ActivatePage;
